// material ui enhancements
import 'muicss/dist/js/mui.min';

// set up locale dropdown
import { bindLocaleEvents } from './locale';
bindLocaleEvents();

// set up form submit spinners
import { bindFormEvents } from './form';
bindFormEvents();

// set up password strength meters
import { bindPasswordEvents } from './password';
bindPasswordEvents();

// set up caps lock indicator
import { bindCapsLockEvents } from './capslock';
bindCapsLockEvents();
